import DetailDialog from '@/components/provincial_level/detail_dialog/detail_dialog';
import QrcodeDialog from '@/components/provincial_level/qrcode_dialog/qrcode_dialog';
import eduSvg from '@/assets/images/provincial/edu.svg';
import companySvg from '@/assets/images/provincial/company.svg';
import allowedSvg from '@/assets/images/provincial/allowed.svg';
import numberSvg from '@/assets/images/provincial/number.svg';
import origanSvg from '@/assets/images/provincial/origan.svg';
import sickSvg from '@/assets/images/provincial/sick.svg';
import numberMarkSvg from '@/assets/images/provincial/number_mark.svg';
import newSvg from '@/assets/images/provincial/new.svg';
import netSvg from '@/assets/images/provincial/net.svg';

export default{
    name : 'edu_service',
    data () {
        return {
            // 是否显示弹出层
            isShowDialog: false,
            // 弹出层标题
            dialogTitle: '',
            newSvg,
            // 弹出层数组
            dialogList: [],
            list: [{
                menuName: '淘法律师',
                menuType: 2,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=10;24;1',
                icon: '#icon-taofa'
            }, {
                menuName: '教育',
                menuType: 1,
                img: eduSvg,
                subMenu: [
                    {menuName: '技工毕业证书',desc: '技工院校毕业证书查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;5;1'},
                    {menuName: '职称证书',desc: '职称证书查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;6;1'},
                    {menuName: '毕业生档案',desc: '毕业生档案查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;7;1'},
                    {menuName: '就业报到证',desc: '就业报到证查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;8;1'},
                    {menuName: '技工毕业证书',desc: '技工院校毕业证书查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;9;1'},
                    {menuName: '职业资格证书',desc: '职业资格证书查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;10;1'},
                    {menuName: '中等职业学校学历',desc: '中等职业学校学历证书查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;12;1'},
                    {menuName: '普通话水平',desc: '普通话水平测试成绩查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;13;1'},
                    {menuName: '自考毕业证书',desc: '湖南省自学考试毕业证书查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;14;1'},
                ]
            },{
                menuName: '号码标记',
                menuType: 2,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=13;2;1',
                img: numberMarkSvg,
                newMenu: true
            },{
                menuName: '网点查询',
                menuType: 2,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=26;1;1',
                img: netSvg,
                newMenu: true
            },{
                menuName: '号码归属',
                menuType: 1,
                img: numberSvg,
                subMenu: [
                    {menuName: '号码归属',desc: '号码归属查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;61;1'},
                ]
            },{
                menuName: '许可',
                menuType: 1,
                img: allowedSvg,
                subMenu: [
                    {menuName: '特种设备设计许可证',desc: '特种设备设计许可证查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;52;1'},
                    {menuName: '特种设备检验检测机构核准',desc: '特种设备检验检测机构核准查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;53;1'},
                    {menuName: '特种设备制造许可证',desc: '特种设备制造许可证查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;54;1'},
                    {menuName: '特种设备安全改造维修许可证',desc: '特种设备安全改造维修许可证查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;55;1'},
                    {menuName: '气瓶充装许可证',desc: '气瓶充装许可证查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;56;1'},
                    {menuName: '全国工业产品生产许可证',desc: '全国工业产品生产许可证（危险品）查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;57;1'},
                    {menuName: '全国工业产品生产许可证',desc: '全国工业产品生产许可证查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;58;1'},
                    {menuName: '食品相关产品生产许可证',desc: '食品相关产品生产许可证查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;59;1'},
                ]
            },{
                menuName: '企业服务',
                menuType: 1,
                img: companySvg,
                subMenu: [
                    {menuName: '公章刻制业名录',desc: '公章刻制业名录查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;50;1'},
                    {menuName: '投资项目公示',desc: '投资项目公示查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;51;1'},
                ]
            },{
                menuName: '疫情咨询',
                menuType: 1,
                img: sickSvg,
                subMenu: [
                    {menuName: '复工复产专栏',desc: '复工复产专栏',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;62;1'},
                    {menuName: '疫情专栏',desc: '疫情专栏',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;63;1'},
                    {menuName: '疫情办事提示',desc: '疫情办事提示',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;64;1'},
                ]
            },{
                menuName: '机构场所',
                menuType: 1,
                img: origanSvg,
                subMenu: [
                    {menuName: '中国驻外使领事联系方式查询',desc: '中国驻外使领事联系方式查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;48;1'},
                ]
            }]
        }
    },
    methods: {
        closeDialog() {
		    this.isShowDialog = false;
        },
		menuClick(item) {
            if(item.menuType == 1) {
                this.isShowDialog = true;
                this.dialogTitle = item.menuName
                this.dialogList = item.subMenu
                return;
            } else if(item.menuType == 2) {
                if(item.url == undefined) {
                    this[item.dialog] = true;
                } else {
                    if(item.url.indexOf('auth') != -1 && window.localStorage.getItem("token") != undefined) {
                        window.location.href = (item.url+ '&token=' + window.localStorage.getItem("token"));
                        return;
                    }
                    window.location.href = item.url
                }
            }
        }
    },
	components: {
        'DetailDialog': DetailDialog,
        'QrcodeDialog': QrcodeDialog
	}
}


// WEBPACK FOOTER //
// ./src/components/provincial_level/query_service/js/query_service.js